import hmac from 'js-crypto-hmac'
import { toHexString } from '@/services/hash/utils'

export const hmacGenerator = async (key: string, data: string) => {
  const HASH_CODE = 'SHA-256'

  const encodedKey = new TextEncoder().encode(key)
  const encodedData = new TextEncoder().encode(data)

  const result = await hmac.compute(encodedKey, encodedData, HASH_CODE)

  return toHexString(result)
}
